/**
 * Utils library - Utility Functions
 * Export all utility functions from this file
 */

// Date utilities
export * from './date.utils';

// Money utilities
export * from './money.utils';

// Validation utilities
export * from './validation.utils';

// Format utilities
export * from './format.utils';

// Contract / lease utilities
export * from './contract.utils';

// Vessel utilities
export * from './vessel.utils';

// Fuel utilities
export * from './fuel.utils';

// Error utilities
export * from './error.utils';

// Web Animations startTime guard (Angular/Material + Chrome)
export * from './web-animations.utils';

// Authorized user / portal role utilities
export * from './authorized-user-role.utils';

// User scope (System / Marina / Client)
export * from './user-scope.utils';

// Blob / PDF viewing (iOS / iPad popup timing)
export * from './open-blob.utils';

// Device services
export * from './services/device-fingerprint.service';
export * from './services/device-token-storage.service';